module.exports = {
	"calendar": 61697,
	"call": 61698,
	"car": 61699,
	"logo": 61700,
	"pc": 61701,
	"person": 61702,
	"phone": 61703,
	"tablet": 61704,
	"venn-intersection": 61705
};


//////////////////
// WEBPACK FOOTER
// ./common/~/json-loader!./common/js/src/edge/platform/widgets/icon/directives/icon/generated/codepoints.json
// module id = 1276
// module chunks = 0